import player from 'lottie-web';
import { LottieOptions } from 'ngx-lottie/lib/symbols';

/**
 * Factory function for creating the Lottie player
 * Used to ensure consistent player instantiation across the app
 */
export function playerFactory() {
  return player;
}

/**
 * Standardized Lottie options to be used application-wide
 */
export const LOTTIE_OPTIONS: LottieOptions = {
  player: playerFactory
};